import { BREAKPOINTS, type Breakpoint } from './constants';
import type { ColumnsSpec } from './types';

/**
 * Parse a `ColumnsSpec` into per-breakpoint column counts.
 * Returns `null` when `spec` is `undefined` — the solver should auto-derive.
 */
export function extractRawColumnsAtBreakpoints(spec: ColumnsSpec | undefined): Record<Breakpoint, number> | null {
  if (spec == null) return null;
  const fallback = 2;
  const result: Record<Breakpoint, number> = {
    base: fallback,
    sm: fallback,
    md: fallback,
    lg: fallback,
    xl: fallback,
  };

  if (typeof spec === 'number') {
    const val = Math.max(1, spec);
    BREAKPOINTS.forEach((bp) => {
      result[bp] = val;
    });
    return result;
  }

  if (typeof spec === 'string') {
    const repeatMatch = spec.match(/repeat\((\d+)/i);
    const parsed = repeatMatch ? parseInt(repeatMatch[1], 10) : parseInt(spec, 10);
    const val = Number.isNaN(parsed) ? fallback : Math.max(1, parsed);
    BREAKPOINTS.forEach((bp) => {
      result[bp] = val;
    });
    return result;
  }

  if (spec && typeof spec === 'object') {
    let current = fallback;
    BREAKPOINTS.forEach((bp) => {
      if (spec[bp] !== undefined) {
        const parsed =
          typeof spec[bp] === 'string' ? parseInt(spec[bp] as string, 10) : (spec[bp] as number);
        current = Number.isNaN(parsed) ? current : Math.max(1, parsed);
      }
      result[bp] = current;
    });
  }

  return result;
}

export const resolveRawColumnsAtBreakpoints = extractRawColumnsAtBreakpoints;
